import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface AuthStore {
  nfcKeyId: string | undefined;
  pin: string | undefined;
  isAuthenticated: boolean;
  login: (key: string, pin: string) => void;
  logout: () => void;
}

const useAuthStore = create<AuthStore>()(
  devtools((set) => ({
    nfcKeyId: undefined,
    pin: undefined,
    isAuthenticated: false,
    login: (key: string, pin: string) =>
      set({ nfcKeyId: key, pin, isAuthenticated: true }),
    logout: () =>
      set({ nfcKeyId: undefined, pin: undefined, isAuthenticated: false }),
  })),
);

export const useAuth = (): {
  nfcKeyId: string | undefined;
  pin: string | undefined;
  isAuthenticated: boolean;
  login: (key: string, pin: string) => void;
  logout: () => void;
} => ({
  nfcKeyId: useAuthStore((state) => state.nfcKeyId),
  pin: useAuthStore((state) => state.pin),
  isAuthenticated: useAuthStore((state) => state.isAuthenticated),
  login: useAuthStore((state) => state.login),
  logout: useAuthStore((state) => state.logout),
});
